import React, { useEffect, useMemo } from "react";
import {
  TableComponent,
  SortingColumnsType,
} from "../../../../../../components/table-component/table";
import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import "../platform.scss";
import { AdminDashboardService } from "../../../../../../core/services/admin-dashboard.service";
import { Loading } from "../../../../../../redux/action";
import { connect, useDispatch } from "react-redux";
import { LoadingButton } from "@mui/lab";
import dayjs from "dayjs";
import { Grid, TextField } from "@mui/material";
import { AdminPageHead, AdminTabs } from '../../components/AdminPageHead';
// common campaign details popup (view + edit) shared with the verification > campaign verification screen
import { CampaignDetailPopup } from "../../components/campaign-detail-popup";

const columnDisplayName = {
  full_name: "Campaign Owner",
  login_email: "Owner Email",
  login_mobile: "Owner Phone",
  campaign_title: "Campaign Name",
  campaign_visibility: "Campaign Visibility",
  created_at: "Created at",
  posted_at: "Posted at",
  status: "Status",
  proposal_dt: "Deadline",
  go_live_dt: "Live Date",
  Content: "Content",
  Proposals: "Proposals",
};

const sortingColumnType: SortingColumnsType[] = [
  {
    name: "full_name",
    columnSize: "180px",
  },
  {
    name: "login_email",
    columnSize: "180px",
  },
  {
    name: "login_mobile",
    columnSize: "120px",
  },
  {
    name: "campaign_title",
    columnSize: "200px",
  },
  {
    name: "campaign_visibility",
    columnSize: "200px",
  },
  {
    name: "created_at",
    columnSize: "180px",
  },
  {
    name: "posted_at",
    columnSize: "180px",
  },
  {
    name: "status",
    columnSize: "80px",
  },
  {
    name: "proposal_dt",
    columnSize: "180px",
  },
  {
    name: "go_live_dt",
    columnSize: "180px",
  },
  {
    name: "Content",
    columnSize: "80px",
  },
  {
    name: "Proposals",
    columnSize: "80px",
  },
];

interface Props {
  loading: (data: any) => any;
  userData: any;
}

const adminDashboardService = new AdminDashboardService();

const PlatformCampaignDetails: React.FC<Props> = (props: Props) => {
  const [renderData, setRenderData] = useState<any>([]);
  const [dashboardCampaignData, setDashboardCampaignData] = useState<any>([]);
  const [formData, setFormData] = useState<any>({
    start_date: "",
    end_date: "",
  });
  const [searchName, setSearchName] = useState("");
  const [loading, setLoading] = useState(false);
  // campaign details popup state
  const [campaignDetail, setCampaignDetail] = useState<any>([]);
  const [openCampaignModal, setOpenCampaignModal] = useState(false);
  const [dateError, setDateError] = useState("");
  const dateFormat = "YYYY-MM-DD";

  const filteredCampaignData = useMemo(() => {
    const search = searchName.trim().toLowerCase();
    if (!search) return dashboardCampaignData;
    return (dashboardCampaignData || []).filter((row: any) =>
      [row.full_name, row.login_email, row.login_mobile, row.campaign_title].some(
        (field: any) => field && String(field).toLowerCase().includes(search)
      )
    );
  }, [dashboardCampaignData, searchName]);

  const hasActiveFilters = Boolean(searchName || formData.start_date || formData.end_date);

  useEffect(() => {
    getPlatformFilter(formData);
  }, []);

  async function handleSearch() {
    try {
      if (!searchName.trim() && !formData.start_date && !formData.end_date) {
        setDateError("Please enter a name/email/phone or select a date range to search");
        return;
      }
      if (formData.start_date === "" && formData.end_date != "") {
        setDateError("Please enter start date");
        return;
      }
      if (formData.end_date === "" && formData.start_date != "") {
        setDateError("Please enter end date");
        return;
      }
      if (formData.start_date > formData.end_date) {
        setDateError("Start date should be less than end date");
        return;
      }
      setDateError("");
      setLoading(true);
      getPlatformFilter(formData);
    } catch (error) {
      console.error("Error fetching handleSearch:", error);
    } finally {
      setLoading(false);
    }
  }

  function handleClear() {
    const resetFormData = {
      start_date: "",
      end_date: "",
    };
    setSearchName("");
    setFormData(resetFormData);
    setDateError("");
    getPlatformFilter(resetFormData);
  }

  // open the campaign details popup on clicking the campaign title
  async function getToCampaign(campaignId: number) {
    try {
      props.loading(true);
      const res = await adminDashboardService.getCampaignDetail(campaignId);
      if (res.status) {
        setCampaignDetail([res.data[0]]);
        setOpenCampaignModal(true);
      }
    } catch (error) {
      console.error("Error fetching campaign detail:", error);
      setCampaignDetail([]);
      setOpenCampaignModal(false);
    } finally {
      props.loading(false);
    }
  }

  function handleCloseCampaignDetailModal() {
    setOpenCampaignModal(false);
  }

  async function getPlatformFilter(formData: any) {
    try {
      props.loading(true);
      setLoading(true);
      const res = await adminDashboardService.getAdminDashCampaignsData(
        formData
      );
      if (res?.data?.status) {
        setDashboardCampaignData(res?.data?.rows);
      }
    } catch (error) {
      console.error("Error fetching getPlatformFilter:", error);
    } finally {
      props.loading(false);
      setLoading(false);
    }
  }

  return (
    <div className="adminDashboardPlatformMostOutterDiv campaign-details-main ">
      <AdminPageHead title="Platform" subtitle="Campaigns and creator feedback across the platform." />
      <AdminTabs tabs={[{ to: '/brand/admin-dashboard/campaign-details', label: 'Campaign Details' }, { to: '/brand/admin-dashboard/disconnect-feedbacks', label: 'Disconnect Feedbacks' }]} />
      {dateError && <span className="error">{dateError}</span>}
      <div className="date_range_search">
        <Grid container spacing={2} sx={{alignItems:'flex-end'}}>
          <Grid item sm={3} md={3} xs={12} xl={3}>
            <TextField
              className="w-100"
              label="Name/Email/Phone"
              size="small"
              value={searchName}
              onChange={(e: any) => setSearchName(e.target.value)}
            />
          </Grid>
          <Grid item sm={3} md={3} xs={12} xl={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["StartDate"]}>
                <MobileDatePicker
                  className="w-100"
                  label="Posted start date"
                  format="DD-MM-YYYY"
                  maxDate={dayjs(new Date())}
                  value={formData.start_date ? dayjs(formData.start_date) : null}
                  onChange={(e: any) =>
                    setFormData({
                      ...formData,
                      start_date: e?.format(dateFormat),
                    })
                  }
                  slotProps={{
                    textField: {
                      size: "small",
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          <Grid item sm={3} md={3} xs={12} xl={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["EndDate"]}>
                <MobileDatePicker
                  className="w-100"
                  format="DD-MM-YYYY"
                  label="Posted end date"
                  maxDate={dayjs(new Date())}
                  value={formData.end_date ? dayjs(formData.end_date) : null}
                  onChange={(e: any) =>
                    setFormData({
                      ...formData,
                      end_date: e?.format(dateFormat),
                    })
                  }
                  slotProps={{
                    textField: {
                      size: "small",
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          <Grid item sm={3} md={3} xs={12} xl={3} className="btn-div">
            <LoadingButton
              className="btn btn-primary btn-sm"
              loading={loading}
              onClick={() => handleSearch()}
            >
              Search
            </LoadingButton>
            {hasActiveFilters && (
              <LoadingButton
                className="btn btn-outline-primary btn-sm ms-2"
                onClick={() => handleClear()}
              >
                Clear
              </LoadingButton>
            )}
          </Grid>
        </Grid>
      </div>

      <div className="adminDashboardPlatformContentDivTable ">
        <TableComponent
          pagination={true}
          columnDisplayName={columnDisplayName}
          inputDataSource={filteredCampaignData}
          orderByColumnName=""
          sortingColumnType={sortingColumnType}
          renderData={renderData}
          setRenderData={(e) => setRenderData(e)}
        >
          {renderData.map((data: any, index: number) => {
            return (
              <TableRow key={index} hover role="checkbox">
                <TableCell>{data.full_name}</TableCell>
                <TableCell>{data.login_email}</TableCell>
                <TableCell>{data.login_mobile}</TableCell>
                {/* old code: <TableCell>{data.campaign_title}</TableCell> */}
                <TableCell>
                  <a href="javascript:void(0);" onClick={() => getToCampaign(data.campaign_id)}>
                    {/* some campaigns have no title, showing a fallback so that the row is still clickable */}
                    {data.campaign_title ? data.campaign_title : 'View details'}
                  </a>
                </TableCell>
                <TableCell>{data.campaign_visibility}</TableCell>
                <TableCell>{data.created_at ? dayjs(data.created_at).format('LL') : ''}</TableCell>
                <TableCell>{data.posted_at ? dayjs(data.posted_at).format('LL') : ''}</TableCell>
                <TableCell>{data.status}</TableCell>
                <TableCell>{data.proposal_dt ? dayjs(data.proposal_dt).format('LL') : ''}</TableCell>
                <TableCell>{data.go_live_dt ? dayjs(data.go_live_dt).format('LL') : ''}</TableCell>
                <TableCell>
                  {data.total_creatives}/{data.approved_creatives}
                </TableCell>
                <TableCell>
                  {data.total_proposals}/{data.accepted_proposals}
                </TableCell>
              </TableRow>
            );
          })}
        </TableComponent>
      </div>

      <CampaignDetailPopup
        openModal={openCampaignModal}
        campaignDetail={campaignDetail}
        onClose={() => handleCloseCampaignDetailModal()}
        onUpdated={() => getPlatformFilter(formData)}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlatformCampaignDetails);
export { connectToRedux as PlatformCampaignDetails };
